import { render, staticRenderFns } from "./supersound.vue?vue&type=template&id=13c06b8d&scoped=true"
import script from "./supersound.vue?vue&type=script&lang=js"
export * from "./supersound.vue?vue&type=script&lang=js"
import style0 from "./supersound.vue?vue&type=style&index=0&id=13c06b8d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c06b8d",
  null
  
)

export default component.exports